<template>
    <div class="range" :class="classes">
        <span class="label" v-if="hasInput">
            {{ prefix }}{{ min.toLocaleString() }}{{ suffix }}&ndash;{{ prefix
            }}{{ max.toLocaleString() }}{{ suffix }} {{ shortLabel }}
        </span>
        <span class="label" v-else>{{ label }}</span>
        <div class="input-wrap">
            <NoUiSlider
                v-if="rangeMax"
                v-model="modelProxy"
                :step="1"
                :range="rangeSnaps"
            />
            <div class="input-boxes">
                {{ label }}
                <input type="number" min="0" v-model="modelProxy[0]" /> to
                <input type="number" min="0" v-model="modelProxy[1]" />
            </div>
        </div>
    </div>
</template>

<script>
import NoUiSlider from "@/components/NoUiSlider.js";

export default {
    name: "Range",
    components: { NoUiSlider },
    props: {
        label: {
            type: String,
            required: true,
        },
        classes: String,
        prefix: { type: String, default: "" },
        suffix: { type: String, default: "" },
        shortLabel: { type: String, default: "" },
        uniqValues: {
            type: Array,
            required: true,
        },
        modelValue: Array,
    },
    data() {
        const vm = this;
        return {
            modelProxy: vm.modelValue,
        };
    },
    computed: {
        hasInput() {
            const vm = this;
            return vm.modelValue[0] != 0 || vm.modelValue[1] < vm.rangeMax;
        },
        min() {
            return this.modelValue[0];
        },
        max() {
            return this.modelValue[1];
        },
        rangeMax() {
            const vm = this;
            if (vm.uniqValues.length == 0) return 0;
            return vm.uniqValues.reduce((a, v) => (v > a ? v : a));
        },
        rangeSnaps() {
            const vm = this;
            const uniques = [...vm.uniqValues];
            uniques.unshift();
            const max = uniques.pop();

            var range = {
                min: 0,
                max: max,
            };
            uniques.forEach(function (u, i) {
                var pct = (i * 100) / uniques.length;
                pct = pct.toFixed(2);
                range[pct + "%"] = [u, 1]; // 1 = step
            });
            return range;
        },
    },
    watch: {
        modelProxy: {
            handler(newValue) {
                const vm = this;
                vm.$emit("update:modelValue", newValue);
            },
            deep: true,
        },
        modelValue: {
            handler(newValue) {
                const vm = this;
                vm.modelProxy = newValue;
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
</style>
